import { InjectionToken } from '@angular/core';

export const CONTAINER_ROOT_TYPE = new InjectionToken<string>(
  'app.context.containerRootType',
);

export enum ContainerType {
  List = 'list',
  Section = 'section',
}
